export default [
  {
    name: "AuthAccountLogin",
    url: "/account/login",
    method: "POST",
    mock: false,
  },
  {
    name: "AuthAccountLogout",
    url: "/account/logout",
    method: "POST",
    mock: false,
  },
  {
    name: "AuthSendResetPasswordEmail",
    url: "/account/reset-password/email",
    method: "POST",
    mock: false,
  },
  {
    name: "AuthResetAccountPassword",
    url: "/account/reset-password",
    method: "POST",
    mock: false,
  },
  {
    name: "AuthResetAccountPasswordExpired",
    url: "/account/reset-password/expired",
    method: "GET",
    mock: false,
  },
  // client ib  修改密码

  {
    name: "AuthChangePassword",
    url: "/account/change-password",
    method: "POST",
    mock: false,
  },
  // 获取安全设置(邮箱和密码)
  {
    name: "AuthGetUserSecuritySetting",
    url: "/account/security-setting",
    method: "GET",
    mock: false,
  },
  // 获取登陆用户的路由、按钮权限
  {
    name: "AuthGetUserAction",
    url: "/menu/action/get",
    method: "GET",
    mock: false,
  },
];
